module.exports = __webpack_public_path__ + "246355df4c951c94e667e0379a4cf9ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/animation-sample/image.png
// module id = 688
// module chunks = 0 1